// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Cookies from 'js-cookie'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en' // lang i18n
import '@/styles/index.scss' // global css
import { i18n } from './lang'
import '@/icons'
import '@/permission' // 权限控制
import App from './App'
import router from './router'
import store from './store'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import axios from 'axios'
import ElIcon from '@/components/icon'
import { zhDateChangeEn } from '@/utils'

import VueQuillEditor from 'vue-quill-editor' // 引入富文本编译器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

Vue.use(MintUI, ElIcon)
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

const echarts = require('echarts')
Vue.prototype.$echarts = echarts
// 判断是否具有某个功能的权限（添加、编辑）
Vue.prototype.hasPermission = function hasPermission(permission) {
  const userPermissions = store.getters.permissions
  return (userPermissions.findIndex(i => i.funCode === permission) > -1) || (this.$store.state.user.loginName === 'admin')
}
Vue.prototype.zhDateChangeEn = zhDateChangeEn

Vue.config.productionTip = false
Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
  locale
})

const on = Vue.prototype.$on
// 节流
Vue.prototype.$on = function (event, func) {
  let previous = 0
  let newFunc = func
  if (event === 'click') {
    newFunc = function () {
      const now = new Date().getTime()
      if (previous + 1000 <= now) {
        func.apply(this, arguments)
        previous = now
      }
    }
  }
  on.call(this, event, newFunc)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js